import { css } from "@emotion/react";
import type { ImmutableObject } from "@/lib/immutable";
import type { PackageItem } from "../../../hooks/useInventoryState";
import { useThemeState } from "../../../hooks/useThemeState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";

export type ShoppingCartPackageItemAvailabilityProps = {
	packageItem: ImmutableObject<PackageItem>;
};
export const ShoppingCartPackageItemAvailability: React.FC<
	ShoppingCartPackageItemAvailabilityProps
> = (props) => {
	const translate = useTranslate();
	const packageItem = props.packageItem;
	const totalIn = packageItem.Availability?.TotalIn ?? 0;
	const themeState = useThemeState();
	const themeName = themeState.get().themeName;

	return (
		<>
			{packageItem.Availability && (
				<div
					className="field availability"
					css={css`display:flex;justify-content:center;font-size:.8rem;white-space:nowrap`}
				>
					{totalIn > 0 && (
						<span
							css={css`${themeName === "dark" ? "color:hsl(180 100% 40% / 1);" : "color:#777777;"}`}
						>
							(
							{(packageItem.Availability?.TotalIn ?? 0).toString() +
								" of " +
								(packageItem.Availability?.Total ?? 0).toString() +
								" " +
								translate("available")}
							)
						</span>
					)}
					{totalIn === 0 && (
						<span css={css`color:hsl(0 0% 40% / 1);`}>
							({translate("Unavailable")})
						</span>
					)}
				</div>
			)}
		</>
	);
};
